import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static values = { interval: { type: Number, default: 2000 } }
  static targets = ["indicator"]

  connect() {
    this.dirty = false
    this.saving = false
    this.markDirty = () => { this.dirty = true }

    // Listen for both standard input and Lexxy's custom change event
    this.element.addEventListener("input", this.markDirty)
    this.element.addEventListener("lexxy:change", this.markDirty)

    this.timer = setInterval(() => this.tick(), this.intervalValue)
  }

  disconnect() {
    clearInterval(this.timer)
    this.element.removeEventListener("input", this.markDirty)
    this.element.removeEventListener("lexxy:change", this.markDirty)
  }

  tick() {
    if (this.dirty && !this.saving) this.save()
  }

  saveNow() {
    if (this.saving || !this.dirty) return
    this.save()
  }

  async save() {
    this.dirty = false
    this.saving = true

    const formData = new FormData(this.element)
    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content

    try {
      const response = await fetch(this.element.action, {
        method: "POST",
        headers: {
          "X-CSRF-Token": csrfToken,
          "Accept": "text/vnd.turbo-stream.html",
          // Lets the server tell an autosave apart from a Turbo form submit,
          // which also accepts turbo streams but expects a redirect.
          "X-Autosave": "1"
        },
        body: formData
      })

      if (response.ok) {
        this.flash()
        // A server that answers with a turbo stream (e.g. the note's public
        // link widget) gets it applied; an empty 200 stays a no-op.
        if ((response.headers.get("Content-Type") || "").includes("turbo-stream")) {
          const html = await response.text()
          if (html.trim()) Turbo.renderStreamMessage(html)
        }
      }
    } catch (e) {
      // Silently fail — user can still manually save
    } finally {
      this.saving = false
    }
  }

  flash() {
    if (!this.hasIndicatorTarget) return
    this.indicatorTarget.classList.remove("opacity-0")
    clearTimeout(this.flashTimer)
    this.flashTimer = setTimeout(() => {
      this.indicatorTarget.classList.add("opacity-0")
    }, 2000)
  }
}
